import React, { memo } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const QuestionBlock = ({ blockName, children }) => (
  <S.Container hasChildren={!!Object.keys(children).length > 0}>
    <S.BlockName>{blockName}</S.BlockName>
    {children}
  </S.Container>
);

export default memo(QuestionBlock);

QuestionBlock.defaultProps = {
  children: [],
};

QuestionBlock.propTypes = {
  blockName: PropTypes.string.isRequired,
  children: PropTypes.node,
};
